import getClassLink from './getClassLink';
import getProgressLink from './getProgressLink';

export default function getHubClassRedirectData(classroomId, organisationId) {
  return {
    platform: 'hub',
    loginUrl: getProgressLink(getClassLink(classroomId), organisationId)
  };
}
